/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { FlinkContext } from "../../../context/FlinkContext";
import overviewCards from "../../Overview/OverviewCard/OverviewDummy";
import Title from "../../Title/Title";
import Table from "../../Table/Table";
import Button from "../../Button/Button";
import Select from "../../Select/Select";
import "../../Content/Content.scss";
import Loading from "../../Loading/Loading";
import PowerNlPowerCharts from "./PowerNlPowerCharts";
import PowerSpotCharts from "./PowerSpotCharts";
import BigTable from "../../Table/BigTable";
import HistoricalModal from "../../HistoricalModal/HistoricalModal";
import AheadTable from "../../Table/AheadTable";
import { aheadDates, dataToAhead } from "../../../Helper/bigTableDates";
import Logger from "../../../Helper/Logger";

function FlinkPower() {
  const [printedChart, setPrintedChart] = useState(null);
  const powerData = useContext(FlinkContext);
  const [base, setBase] = useState("Base");
  const [tableData, setTableData] = useState();
  const [list, setList] = useState(null);
  const [charts, setCharts] = useState(null);
  const [ahead, setAhead] = useState();

  const modalData = [
    powerData?.power?.powerTable?.pricesSpotBase,
    powerData?.power?.powerTable?.pricesSpotPeak,
    powerData?.power?.powerTable?.pricesSpotOffPeak,
  ];

  const basePeakHandler = (value) => {
    if (value === "Base") {
      setTableData([...powerData?.power?.powerTable?.pricesTableBase]);
      setList([
        ...powerData.power.forwardChartBase.map((item) => {
          if (item.marketName === "NL Base Y+1") {
            return {
              marketName: item.marketName,
              cheked: true,
              chart: item.chart,
            };
          } else {
            return {
              marketName: item.marketName,
              cheked: false,
              chart: item.chart,
            };
          }
        }),
      ]);
      setAhead([dataToAhead(powerData?.power?.powerTable?.pricesSpotBase)]);
    }
    if (value === "Peak") {
      setTableData([...powerData?.power?.powerTable?.pricesTablePeak]);
      setList([
        ...powerData.power.forwardChartPeak.map((item) => {
          if (item.marketName === "NL Peak Y+1") {
            return {
              marketName: item.marketName,
              cheked: true,
              chart: item.chart,
            };
          } else {
            return {
              marketName: item.marketName,
              cheked: false,
              chart: item.chart,
            };
          }
        }),
      ]);
      setAhead([dataToAhead(powerData?.power?.powerTable?.pricesSpotPeak)]);
    }

    if (value === "Hourly") {
      setTableData([...powerData?.power?.powerTable?.pricesTableHourly]);
      setList([
        ...powerData.power.hourlyChart.map((item) => {
          if (item.marketName === "NL Spot Hour") {
            return {
              marketName: item.marketName,
              cheked: true,
              chart: item.chart,
            };
          } else {
            return {
              marketName: item.marketName,
              cheked: false,
              chart: item.chart,
            };
          }
        }),
      ]);
      setAhead(null);
    }

    if (value === "OffPeak") {
      setTableData([...powerData?.power?.powerTable?.pricesTableOffPeak]);
      setList([
        ...powerData.power.forwardChartOffPeak.map((item) => {
          if (item.marketName === "NL Offpeak Y+1") {
            return {
              marketName: item.marketName,
              cheked: true,
              chart: item.chart,
            };
          } else {
            return {
              marketName: item.marketName,
              cheked: false,
              chart: item.chart,
            };
          }
        }),
      ]);
      setAhead([dataToAhead(powerData?.power?.powerTable?.pricesSpotOffPeak)]);
    }
  };

  useEffect(() => {
    if (powerData?.power?.powerTable) {
      basePeakHandler(base);
    }
  }, [base, powerData]);

  useEffect(() => {
    if (list) {
      setPrintedChart(list.filter((l) => l.marketName.includes("Y")));
      setCharts(list.filter((item) => item.cheked === true));
    }
  }, [list]);

  const [isOpen, setIsOpen] = useState(false);

  return powerData.power && list && charts ? (
    <>
      <div id="power" className="FlinkPower Flink-container">
        <Title title="Power" icon={overviewCards.power.icon} />
        <div className="row">
          <Logger op="Chart" id="17148" className="col-md-6 col-sm-12">
            <PowerSpotCharts data={powerData?.power?.spotChart} />
            <div className="selectP d-flex justify-content-center">
              {base === "Hourly" ? (
                <p
                  className="text-center chartTitleP"
                  style={{ margin: "20px 0 10px 0" }}
                >
                  NL Spot Hour
                </p>
              ) : (
                <Select list={list} onSaveList={setList} />
              )}
            </div>
            <PowerNlPowerCharts
              charts={charts}
              printedChart={printedChart}
              type={base}
            />
          </Logger>
          <Logger op="News" id="40110" className="col-md-6 col-sm-12">
            <div className="d-flex justify-content-center buttonP">
              <Button base={base} onBtnChaghe={setBase} />
            </div>
            {ahead && (
              <AheadTable
                openModal={setIsOpen}
                firstThName="Power"
                data={ahead}
              />
            )}
            <Table
              noAhead
              type={base}
              openModal={setIsOpen}
              revert
              date2={
                base === "Hourly"
                  ? powerData?.power?.powerTable?.date4
                  : powerData?.power?.powerTable?.date2
              }
              date1={
                base === "Hourly"
                  ? powerData?.power?.powerTable?.date3
                  : powerData?.power?.powerTable?.date1
              }
              firstThName="Power"
              showBtn="none"
              data={tableData}
            />
          </Logger>
        </div>
      </div>
      <HistoricalModal open={isOpen} onClose={() => setIsOpen(false)}>
        <BigTable showBtn="none" firstThName="NL Power" data={modalData} />
      </HistoricalModal>
    </>
  ) : (
    <Loading />
  );
}

export default FlinkPower;
